import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog(props) {


  const handleSaveClicked = () => {
    props?.handleSaveClicked();
    props?.setOpen(false);
    
  };

  const handleClose = () => {
    props?.setOpen(false);
  };

  return (
    <div>
     
      <Dialog
        fullScreen
        open={props?.open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        {
          !props?.activeShadow?
        <AppBar sx={{ position: 'relative',backgroundColor:'#5f7b8a',boxShadow:props?.activeShadow?'none':'auto' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {props?.title}
            </Typography>
            {/* <Button autoFocus color="inherit" onClick={()=>{handleSaveClicked()}}>
              حفظ
            </Button> */}
          </Toolbar>
        </AppBar>:null
       }
        {props.children}
      </Dialog>
    </div>
  );
}
